import axios from 'axios';

const userLang = navigator.language || navigator.userLanguage;
const langCode = userLang.split('-');
const apiKey = document.querySelector("meta[name='cst-api-key']").getAttribute('content');
const instance = axios.create({
   baseURL: `https://api.carecusoft.com/${langCode[0]}/v1/`,
    params: {
        key: apiKey
    }
});

// baseURL: `http://remapsapi/${langCode[0]}/v1/`,

export default instance
